const APPROVAL_REQUESTS = {
  addressProof: 'address_proof',
  curp: 'curp',
  identification: 'identification'
};

export default APPROVAL_REQUESTS;
